export function createLocalSessionId(): string {
  const random = globalThis.crypto?.randomUUID?.() ?? Math.random().toString(36).slice(2);
  return `local-${random}`;
}

export const TICKET_TEMPLATE_NO = "No. 20260701";

export function createTicketCode(date = new Date()): string {
  const source = `${Date.now()}${Math.random()}`;
  const digits = Array.from(source.replace(/\D/g, "")).slice(-6).join("").padStart(6, "0");
  return `RC-${date.getFullYear()}-${digits}`;
}

export function todayLabel(date = new Date()): string {
  return new Intl.DateTimeFormat("zh-CN", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  })
    .format(date)
    .replaceAll("/", ".");
}
